import React, { useState } from 'react';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, Radio, RadioGroup, Switch, Tab, TextField, Typography } from '@mui/material';
import Cancel from './../../../../assets/icons/close.png'
import AutoCompleteMultiSelect from '../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx';

import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import checked from './../../../../assets/icons/checked.png'
import './KycDetails.css'

function KycDetails(props) {
    const [tableData, setTableData] = useState(
        {
            documentDetail: []
        }
    )

    const handleClose = () => {
        props.onClose(false)
    }
    const [radiovalue, setRadioValue] = React.useState('No');
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadioValue((event.target as HTMLInputElement).value);
        console.log("(event.target as HTMLInputElement).value: " + (event.target as HTMLInputElement).value);

        // setitemdata();
    };
    const textFieldValue = (props) => {
        console.log(props)
        // setAutoCompleteValue(props)
    }
    const apiAddress = process.env.REACT_APP_SECRET;

    const approvedData = async () => {
        console.log("selectedData: " + selectedData);
        axios({
            method: 'put',
            url: apiAddress + '/api/KYCForm/updateKycRequests/' + 1,
            data: selectedData
        })
            .then(function (response) {
                console.log(response);
                toast.success("Successfully Saved", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                props.onClose();
            })
            .catch(function (error) {
                console.log(error);
                toast.error("Error" + error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }


    const [companyDetails, setcompanyDetails] = React.useState({
        id: "",
        restaurantId: "",
        legalNameOFCompany: "",
        registeredCountry: "",
        companyRegistrationNumber: "",
        state: "",
        tradeName: "",
        city: "",
        typeOfBusinessId: "",
        houseNumber: "",
        vatOrTaxNumber: "",
        postalcode: "",
        incorporationDate: "",
        billingAddress: "",
        countryCode: "",
        isListedOnStockExchange: true,
        isNotForProfitOrg: true,
        lengthOfBusiness: 5,
        website: "",
        detailsDescriptionOfProduct: "",
        isAllDomainOwn: true,
        primaryCurrencyTypeId: "",
        expectedMonthlyTurnOver: 5.00,
        avgTransactionValue: 55.00,
        highestTransactionValue: 5.00,
        hasRecurringPaymentsOffer: false,
        isOfferTrailPeriods: false,
        approvalStatusId: "",
        isActive: true,
        creationId: "",
        approvalStatusDescription: "",
        creationDate: "",
        modifierId: null,
        modificationDate: "",
        name: ""
    });
    const [directors, setdirectors] = React.useState([]);
    const [ubo, setUbo] = React.useState([]);
    const [gbp, setGbp] = React.useState({
        id: "",
        kycCompanyDetailsId: "",
        settlementCurrencytype: 0,
        accountHolder: "",
        shortCode: "",
        accountNumber: "",
        iban: "",
        creationId: ""
    });
    const [euro, setEuro] = React.useState(
        {
            id: "",
            kycCompanyDetailsId: "",
            settlementCurrencytype: 0,
            accountHolder: "",
            shortCode: "",
            accountNumber: "",
            iban: "",
            creationId: ""
        }
    );
    const [principleContact, setprincipleContact] = React.useState(
        {
            id: "",
            kycCompanyDetailsId: "",
            firstName: "",
            lastName: "",
            emailAddress: "",
            phoneNumber: "",
            creationId: ""
        }
    );
    const [selectedData, setSelectedData] = React.useState(
        []
    );
    React.useEffect(() => {
        setcompanyDetails({
            id: "",
            restaurantId: "",
            legalNameOFCompany: "",
            registeredCountry: "",
            companyRegistrationNumber: "",
            state: "",
            tradeName: "",
            city: "",
            typeOfBusinessId: "",
            houseNumber: "",
            vatOrTaxNumber: "",
            postalcode: "",
            incorporationDate: "",
            billingAddress: "",
            countryCode: "",
            isListedOnStockExchange: true,
            isNotForProfitOrg: true,
            lengthOfBusiness: 5,
            website: "",
            detailsDescriptionOfProduct: "",
            isAllDomainOwn: true,
            primaryCurrencyTypeId: "",
            expectedMonthlyTurnOver: 5.00,
            avgTransactionValue: 55.00,
            highestTransactionValue: 5.00,
            hasRecurringPaymentsOffer: false,
            isOfferTrailPeriods: false,
            approvalStatusId: "",
            isActive: true,
            creationId: "",
            approvalStatusDescription: "",
            creationDate: "",
            modifierId: null,
            modificationDate: "",
            name: ""
        })
        setUbo([]);
        setdirectors([]);

        setGbp({
            id: "",
            kycCompanyDetailsId: "",
            settlementCurrencytype: 0,
            accountHolder: "",
            shortCode: "",
            accountNumber: "",
            iban: "",
            creationId: ""
        });
        setEuro({
            id: "",
            kycCompanyDetailsId: "",
            settlementCurrencytype: 0,
            accountHolder: "",
            shortCode: "",
            accountNumber: "",
            iban: "",
            creationId: ""
        });

        setprincipleContact(
            {
                id: "",
                kycCompanyDetailsId: "",
                firstName: "",
                lastName: "",
                emailAddress: "",
                phoneNumber: "",
                creationId: ""
            }
        )

        if (props.data.companyDetail != undefined) {
            var d = props.data.companyDetail.find(x => x.id == props.selectedData);
            if (d != undefined) {
                var datas = [];
                datas.push(d.id);
                setSelectedData(datas);
                setcompanyDetails(d);
                var personels = props.data.personelLists.filter(x => x.kycCompanyDetailsId == d.id);
                if (personels.length > 0) {
                    var director = personels.filter(x => x.personelsType == 'Director');

                    setdirectors(director);

                    var ubo = personels.filter(x => x.personelsType == 'UBO');
                    setUbo(ubo);
                }

                console.log("d.id: " + d.id);
                var gbpList = props.data.paymentAcceptanceDetails.find(x => x.kycCompanyDetailsId == d.id && x.settlementCurrencytype == 2);
                if (gbpList != undefined) {
                    setGbp(gbpList);
                }

                var euroList = props.data.paymentAcceptanceDetails.find(x => x.kycCompanyDetailsId == d.id && x.settlementCurrencytype == 1);

                if (euroList != undefined) {
                    setEuro(euroList);
                }

                var principleContact = props.data.principleContacts.find(x => x.kycCompanyDetailsId == d.id);

                if (principleContact != undefined) {
                    setprincipleContact(principleContact);
                }

                axios({
                    method: 'get',
                    url: apiAddress + '/api/KYCForm/getKycDocumentDetailsWithUrl/' + d.id,

                })
                    .then(function (response) {
                        console.log(response);
                        setTableData(response.data)
                        // props.onClose();
                    })
                    .catch(function (error) {
                        console.log(error);

                    });
            }

        }

    }, [props])
    console.log(tableData)
    const [Tabvalue, setTabValue] = React.useState('1');

    const handleChange = (event: React.SyntheticEvent, newTabValue: string) => {
        setTabValue(newTabValue);
    };
    return (
        <div>
            <ToastContainer />
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth='lg'
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>Kyc Details</DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>

                        <TabContext value={Tabvalue}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} >
                                    <Tab label="Kyc form" value="1" />
                                    <Tab label="Documents" value="2" />

                                </TabList>
                            </Box>
                            <TabPanel value="1">

                                <div className='p-3 kycform'>

                                    <div className='d-flex align-items-center justify-content-between'>
                                        <h3 className='headerName' style={{ fontSize: "1.8rem" }}> Applying Company </h3>

                                    </div>
                                    <Grid container spacing={5} sx={{ padding: '0.5rem', paddingLeft: "5rem", paddingRight: "5rem", paddingTop: "2rem" }}>

                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Restaurant Name'} value={textFieldValue} val={companyDetails.name} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>

                                            <TextAreaComponents label={'Legal name of company'} val={companyDetails.legalNameOFCompany} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Registered country'} val={companyDetails.registeredCountry} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={' Company registration number'} val={companyDetails.companyRegistrationNumber} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'State'} val={companyDetails.state} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Registered DBA (doing business as)/ trade name'} val={companyDetails.tradeName} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'City'} val={companyDetails.city} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Type of business'} val={companyDetails.typeOfBusinessId} id={5}></TextAreaComponents>
                                        </Grid>
                                        {/* <Grid item xs={6}>
                                    <TextAreaComponents label={'Registered street address'} val={companyDetails.typeOfBusinessId} id={5}></TextAreaComponents>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextAreaComponents label={'Licanse number and place of issues (if applicable)'} val={companyDetails.typeOfBusinessId} id={5}></TextAreaComponents>
                                </Grid> */}
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'House number'} val={companyDetails.houseNumber} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'VAT / Tax identification number'} val={companyDetails.vatOrTaxNumber} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Postal code / Zip code'} val={companyDetails.postalcode} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>

                                            <TextAreaComponents label={'Incorporation Date'} val={companyDetails.incorporationDate} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Billing address (if differ from registered address)'} val={companyDetails.billingAddress} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Country Code'} val={companyDetails.countryCode} id={5}></TextAreaComponents>
                                        </Grid>
                                    </Grid>
                                    <hr style={{ paddingLeft: "5rem", paddingRight: "5rem" }}></hr>
                                    <div className='d-flex align-items-center justify-content-between' style={{ gap: "10px" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.2rem" }}> Is the company publicly listed on a stock exchange? </h3>
                                        <div>

                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={companyDetails.isListedOnStockExchange}
                                            // onChange={handleprofitRadioChange}
                                            >
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                            </RadioGroup>
                                        </div>
                                    </div>
                                    <hr style={{ paddingLeft: "5rem", paddingRight: "5rem" }}></hr>
                                    <div className='d-flex align-items-center justify-content-between' style={{ gap: "10px", marginTop: "1rem", marginBottom: "1.5rem" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.2rem" }}> Is the company a resgistered 'not-for-profit' organization? </h3>
                                        <div>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={companyDetails.isNotForProfitOrg}
                                            // onChange={handlestockRadioChange}
                                            >
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                            </RadioGroup>
                                        </div>
                                    </div>
                                    <div className='d-flex  ' style={{ flexDirection: "column", marginTop: "2rem" }}>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <h3 className='headerName' style={{ fontSize: "1.8rem" }}> Management & Ownership </h3>

                                        </div>


                                    </div>

                                    <div className='' style={{ gap: "10px" }}>
                                        {
                                            directors.map((data, index) => {
                                                return (
                                                    <div className='managementCards'>
                                                        <h3 className='headerName' style={{ fontSize: "1.2rem" }}> Directors & Authorised Signatories <b style={{ fontWeight: "bolder" }}>(Person {data.rank})</b> </h3>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'First name'} val={data.firstName} id={5}></TextAreaComponents>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'Last name'} val={data.lastName} id={5}></TextAreaComponents>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'Date of birth'} val={data.dob} id={5}></TextAreaComponents>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'Home address'} val={data.homeAddress} id={5}></TextAreaComponents>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'Postal code/Zip code '} val={data.zipCode} id={5}></TextAreaComponents>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'City'} val={data.city} id={5}></TextAreaComponents>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'Country'} val={data.country} id={5}></TextAreaComponents>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'Phone number'} val={data.phoneNumber} id={5}></TextAreaComponents>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'Email Address'} val={data.emailAddress} id={5}></TextAreaComponents>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextAreaComponents label={'Passport / ID number'} val={data.passportOrIdNumber} id={5}></TextAreaComponents>
                                                            </Grid>
                                                        </Grid>

                                                    </div>
                                                )
                                            })

                                        }


                                    </div>
                                    <div>

                                    </div>
                                    <div className='d-flex align-items-center justify-content-between' style={{ marginTop: "2rem", gap: "10px" }}>
                                        <div className='d-flex align-items-center' style={{ gap: "10px" }}>
                                            <h3 className='headerName' style={{ fontSize: "1.8rem" }}> Ultimate Beneficial Owner(s) </h3>

                                        </div>

                                    </div>

                                    <div className='d-flex' style={{ gap: "10px" }}>
                                        <div className='' style={{ gap: "10px" }}>
                                            {
                                                ubo.map((data, index) => {
                                                    return (
                                                        <div className='managementCards'>
                                                            <h3 className='headerName' style={{ fontSize: "1.2rem" }}> Directors & Authorised Signatories <b style={{ fontWeight: "bolder" }}>(Person {data.rank})</b> </h3>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'First name'} val={data.firstName} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Last name'} val={data.lastName} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Date of birth'} val={data.dob} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Home address'} val={data.homeAddress} id={5}></TextAreaComponents>
                                                                </Grid>

                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Postal code/Zip code '} val={data.zipCode} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'City'} val={data.city} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Country'} val={data.country} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Phone number'} val={data.phoneNumber} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Email Address'} val={data.emailAddress} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Passport / ID number'} val={data.passportOrIdNumber} id={5}></TextAreaComponents>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextAreaComponents label={'Ownership %'} val={data.ownerShipPercentage} id={5}></TextAreaComponents>
                                                                </Grid>
                                                            </Grid>

                                                        </div>
                                                    )
                                                })

                                            }
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center' style={{ gap: "10px" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.8rem" }}> Business Profile </h3>
                                    </div>
                                    <div style={{ padding: '0.5rem', paddingLeft: "5rem", paddingRight: "5rem", paddingTop: "1rem" }}>
                                        <Grid container spacing={2} >

                                            <Grid item xs={6}>
                                                <TextAreaComponents label={'Length of time in business '} val={companyDetails.lengthOfBusiness} id={5}></TextAreaComponents>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextAreaComponents label={'Website'} val={companyDetails.website} id={5}></TextAreaComponents>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextAreaComponents label={'Detailed description of products /services sold'} val={companyDetails.detailsDescriptionOfProduct} id={1}></TextAreaComponents>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextAreaComponents label={'Does Company own all the domains? '} val={companyDetails.isAllDomainOwn} id={1}></TextAreaComponents>
                                            </Grid>

                                        </Grid>
                                    </div>

                                    <div className='d-flex align-items-center' style={{ gap: "10px", marginTop: "1rem" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.8rem" }}>  Financial Details  </h3>
                                    </div>
                                    <div style={{ padding: '0.5rem', paddingLeft: "5rem", paddingRight: "5rem", paddingTop: "1rem" }}>
                                        <Grid container spacing={2} >

                                            <Grid item xs={6}>
                                                <TextAreaComponents label={'Primary Currency '} val={companyDetails.primaryCurrencyTypeId} id={5}></TextAreaComponents>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextAreaComponents label={'Expected monthly turnover*'} val={companyDetails.expectedMonthlyTurnOver} id={5}></TextAreaComponents>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextAreaComponents label={'Average transaction value '} val={companyDetails.avgTransactionValue} id={5}></TextAreaComponents>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextAreaComponents label={'Highest transaction value '} val={companyDetails.highestTransactionValue} id={5}></TextAreaComponents>
                                            </Grid>

                                        </Grid>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between' style={{ gap: "10px", marginTop: "1rem" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.2rem" }}> Do you offer subscription or other types of recurring payment? *</h3>
                                        <div>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={companyDetails.hasRecurringPaymentsOffer}
                                            >
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                            </RadioGroup>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between' style={{ gap: "10px", marginTop: "1rem" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.2rem" }}> Do you offer free trial periods? *</h3>
                                        <div>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={companyDetails.isOfferTrailPeriods}

                                            >
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                            </RadioGroup>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center' style={{ gap: "10px", marginTop: "2rem" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.8rem" }}>  Payment Acceptance Details  </h3>
                                    </div>

                                    <div className='d-flex align-items-center' style={{ gap: "10px", marginTop: "10px" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.2rem" }}> Settlement currency: GBP</h3>
                                    </div>
                                    <Grid container spacing={2} sx={{ padding: '0.5rem', paddingLeft: "5rem", paddingRight: "5rem", paddingTop: "1rem" }}>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Account holder(beneficiary) '} value={textFieldValue} val={gbp.accountHolder} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Sort Code '} value={textFieldValue} val={gbp.shortCode} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Account Number '} value={textFieldValue} val={gbp.accountNumber} id={5}></TextAreaComponents>
                                        </Grid>
                                    </Grid>
                                    <div className='d-flex align-items-center' style={{ gap: "10px", marginTop: "10px" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.2rem" }}> Settlement currency: EUR</h3>
                                    </div>
                                    <Grid container spacing={2} sx={{ padding: '0.5rem', paddingLeft: "5rem", paddingRight: "5rem", paddingTop: "1rem" }}>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Account holder(beneficiary) '} value={textFieldValue} id={5} val={euro.accountHolder}> </TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'IBAN'} value={textFieldValue} id={5} val={euro.iban}></TextAreaComponents>
                                        </Grid>
                                    </Grid>


                                    <div className='d-flex align-items-center' style={{ gap: "10px", marginTop: "2rem" }}>
                                        <h3 className='headerName' style={{ fontSize: "1.8rem" }}>   Principal Contact  </h3>
                                    </div>

                                    <Grid container spacing={2} sx={{ padding: '0.5rem', paddingLeft: "5rem", paddingRight: "5rem", paddingTop: "1rem" }}>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'First name'} value={textFieldValue} val={principleContact.firstName} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Last name '} value={textFieldValue} val={principleContact.lastName} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Email address'} value={textFieldValue} val={principleContact.emailAddress} id={5}></TextAreaComponents>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextAreaComponents label={'Phone number'} value={textFieldValue} val={principleContact.phoneNumber} id={5}></TextAreaComponents>
                                        </Grid>
                                    </Grid>
                                    <div className='d-flex justify-content-end'>
                                        {companyDetails.approvalStatusDescription == "Pending" ? (
                                            <Button onClick={() => { approvedData() }}>Approve</Button>
                                        ) : ""}
                                        <Button onClick={() => { handleClose() }}>Close</Button>
                                    </div>
                                </div>

                            </TabPanel>
                            <TabPanel value="2">
                                {/* <DocumentsUpload parentData={dataFromDocument}/> */}
                                <table className='table table-striped mt-4' style={{ width: '100%' }}>
                                    <tr>
                                        <th>Name</th>
                                        <th>Status</th>
                                        <th>Documents</th>

                                    </tr>
                                    {tableData != undefined && tableData.documentDetail.map((data, index) => {
                                        return (
                                            <tr key={index}>
                                                <td style={{ width: '30%' }}>
                                                    <h6> {data.name}</h6>
                                                    <p className='tableDescription'>{data.description}</p>
                                                </td>
                                                <td style={{ width: '30%' }}>
                                                    <div className='d-flex'>
                                                        <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                                                        <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>
                                                    </div>

                                                </td>
                                                <td>
                                                    {data.urls.map((dt, index) => (
                                                        // <p key={index}>{dt.documentUrl}</p>
                                                        <a href={dt.documentUrl} download target="_blank">{data.name + ' document'}</a>
                                                    ))}
                                                </td>
                                            </tr>
                                        )
                                    })}



                                </table>
                            </TabPanel>

                        </TabContext>
                    </DialogContent>
                </Dialog>
            </React.Fragment>

        </div>
    );
}

export default KycDetails;